export enum ABTestMboxes {
  //TAL-38
  CALENDLY_LINK_RELOCATED = 'tal-38-calendly-link-relocated',
  CALENDLY_LINK_CLICKED = 'tal-38-clicked-calendly-link',
  CALENDLY_APPOINTMENT_SCHEDULED = 'tal-38-scheduled-a-call'
}

export const ABTestMboxesArray = Object.values(ABTestMboxes);
